<div class="area" data-test="fundo-bloqueado" (click)="solicitar.emit()">
    <div class="fundo" aria-hidden="true">
        <ng-container *ngIf="fundo === 'grade'">
            <div class="linha cabecalho">
                <span class="celula larga"></span><span class="celula"></span><span class="celula"></span><span class="celula"></span>
            </div>
            <div class="linha" *ngFor="let _ of linhasDeExemplo">
                <span class="celula larga"></span><span class="celula"></span><span class="celula"></span><span class="celula"></span>
            </div>
        </ng-container>

        <div class="formulario" *ngIf="fundo === 'formulario'">
            <div class="campo" *ngFor="let _ of camposDeExemplo">
                <span class="rotulo"></span>
                <span class="entrada"></span>
            </div>
        </div>

        <div class="painel" *ngIf="fundo === 'dashboard'">
            <div class="cartoes">
                <div class="cartao" *ngFor="let _ of cartoesDeExemplo">
                    <span class="rotulo"></span>
                    <span class="valor"></span>
                </div>
            </div>
            <div class="grafico">
                <span class="barra" *ngFor="let altura of barrasDeExemplo" [style.height.%]="altura"></span>
            </div>
        </div>
    </div>
</div>
